import Client from './client';

export default class Classifications extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/courthouse/${organization}/classifications`, {
      ...options,
       method: 'POST',
    });
  }

  getClassified(organization, options = {}) {
    return this.makeRequest(`${this.host}/courthouse/${organization}/classifications/classified`, options);
  }

  getOutstanding(organization, options = {}) {
    return this.makeRequest(`${this.host}/courthouse/${organization}/classifications/outstanding`, options);
  }

}
